import React, { useCallback, useState } from 'react';
import T from 'prop-types';
import qs from 'qs';

import ModalDownload from '../../../components/ModalDownload';
import { initParams } from '../configs';

const {
  downloadMarketReportUrl,
  downloadCustomS3ReportUrl,
  downloadReport,
  downloadExport,
  kpiForecastsDatapacksUrl,
} = initParams;

const hasReport = [
  downloadMarketReportUrl,
  downloadCustomS3ReportUrl,
  downloadReport,
  downloadExport,
  kpiForecastsDatapacksUrl,
].some(Boolean);

const DownloadReportModal = ({ currentPage }) => {
  const [modalDownloadOpen, setModalDownloadOpen] = useState(hasReport);

  const getModalTitle = () => {
    if (downloadMarketReportUrl) return 'Your Market Report Is Available';
    if (downloadCustomS3ReportUrl) return 'Your Custom Report is Ready';
    if (kpiForecastsDatapacksUrl) return 'Your KPI Forecasts Are Ready';

    return 'Your Report is Ready';
  };

  const getDownloadUrl = () => {
    if (downloadMarketReportUrl) return downloadMarketReportUrl;

    if (downloadCustomS3ReportUrl) return downloadCustomS3ReportUrl;

    if (kpiForecastsDatapacksUrl) return kpiForecastsDatapacksUrl;

    if (downloadReport) {
      const downloadParams = {
        research_library: {
          id: downloadReport.id,
          event_type: 'download_from_email',
          filters: {
            report_types: downloadReport.report_types,
            geographies: downloadReport.geographies,
          },
        },
      };
      return `/research_library/download?${qs.stringify(downloadParams, { arrayFormat: 'brackets' })}`;
    }

    if (downloadExport) return `/custom_exports/${downloadExport.id}`;

    return '';
  };

  const handleCloseModal = useCallback(() => {
    setModalDownloadOpen(false);

    const { origin, pathname } = window.location;
    const newUrl = `${origin + pathname}#${currentPage}`;
    window.history.replaceState('', '', newUrl);
  }, [currentPage]);

  return modalDownloadOpen && (
    <ModalDownload
      open={modalDownloadOpen}
      title={getModalTitle()}
      downloadUrl={getDownloadUrl()}
      onClose={handleCloseModal}
      onDownload={handleCloseModal}
    />
  );
};

DownloadReportModal.propTypes = {
  currentPage: T.string.isRequired,
};

export default DownloadReportModal;
